<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
		  <el-breadcrumb-item>分销商设置</el-breadcrumb-item>
		</el-breadcrumb>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="预付款" name="first">
				<el-form label-width="12.5rem" :model="advanceAmountForm" class="user-search">
				  <el-form-item label="预付款余额不足提醒">
				    <el-input size="small" v-model="advanceAmountForm.noticeAmount" placeholder="请输入" style="width: 12.5rem;"></el-input>
				  </el-form-item>
				  <el-form-item label="提醒接收手机">
					<el-input size="small" placeholder="请输入" v-model="inputPhone"  style="width: 12.5rem;"></el-input><el-button size="small" type="primary" icon="el-icon-add" @click="appendPhone()">追加</el-button>
					<div v-for="(k) in advanceAmountForm.phone" :key="k">
						{{k}}
					</div>
				  </el-form-item>
					<el-form-item label="停止核销服务阈值">
					  <el-input size="small" v-model="advanceAmountForm.stopLimit" placeholder="请输入"  style="width: 12.5rem;"></el-input>
					</el-form-item>
					<el-form-item>
					  <el-button size="small" type="primary" icon="el-icon-add" @click="submitAdvanceAmount()">提交</el-button>
					  <el-button size="small" type="danger" icon="el-icon-cancel" @click="cancelAdvanceAmount()">取消</el-button>
					</el-form-item>
				</el-form>
			</el-tab-pane>
			<el-tab-pane label="账期" name="second">
				<el-button size="small" type="primary" @click="appendPeriod()">添加账期</el-button>
				<el-table size="small" :data="acountDateTab" highlight-current-row v-loading="loading" border element-loading-text="加载中" style="width: 100%;">
					<el-table-column sortable prop="id" label="账期id" width="200">
					</el-table-column>
					<el-table-column sortable prop="beginTime" label="账期开始" width="200">
					</el-table-column>
					<el-table-column sortable prop="stopTime" label="账期结束" width="150">:visible.sync="productSetLadderVistor"
					</el-table-column>
					<el-table-column align="center" label="操作" min-width="400">
						<template slot-scope="perioddata">
							<el-button size="mini" @click="appendFeeConf(perioddata.row.id)">设置服务费</el-button>
							<el-button size="mini" @click="openProductSet(perioddata.row.id)">开通产品</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
		</el-tabs>
		<el-dialog :visible.sync="addPeriodVisr" width="30%" >
      <el-form label-width="80px" :model="addPeriodForm">
        <el-form-item label="账期" prop="userSex">
          <el-date-picker
								v-model="addPeriodForm.dates"
								type="daterange"
								align="right"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								format="yyyy-MM-dd"	value-format="yyyy-MM-dd"
								end-placeholder="结束日期">
							</el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='cancelAddPeriod()'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitAddPeriod()">保存</el-button>
      </div>
    </el-dialog>


		<el-dialog :visible.sync="settingConfVisr" width="30%" >
			<el-form label-width="12.5rem" :model="serverFeeForm" class="user-search">
					<el-form-item label="服务费合作方式">
						<el-radio v-model="serverFeeForm.serverWay" label="1">固定比例</el-radio>
						<el-radio v-model="serverFeeForm.serverWay" label="2">按阶梯</el-radio>
					</el-form-item>
					<div v-if="serverFeeForm.serverWay == '1'">
						<el-form-item label="服务比例">
							<el-input size="small" v-model="serverFeeForm.serviceTariffing" placeholder="请输入" style="width: 7.5rem;"></el-input>%
						</el-form-item>
					</div>
					<div v-if="serverFeeForm.serverWay == '2'">
						<div v-for="(item,i ) in serverFeeForm.jtdata" v-bind="item">
							<div style="padding: top 1rem;">
								<el-input size="small" v-model="item.minMoney" placeholder="结算金额" style="width: 12.5rem;"></el-input>~<el-input size="small" v-model="item.maxMoney"  placeholder="结算金额" style="width: 12.5rem;"></el-input>
							</div>
							<div style="padding: bottom 1rem;">
								<el-input size="small" v-model="item.serviceTariffing"  placeholder="比例" style="width: 7.5rem;"></el-input>%
							</div>	
						</div>
					</div>
					<el-form-item label="结算方式">
							<el-radio v-model="serverFeeForm.clearingForm" label="1">手工结算</el-radio>
							<el-radio v-model="serverFeeForm.clearingForm" label="2">自动结算</el-radio>
						</el-form-item>
						<el-form-item label="备注">
							<el-input size="small" v-model="serverFeeForm.note"  style="width: 12.5rem;"></el-input>
						</el-form-item>
					<el-form-item>
							<el-button size="small" type="primary" @click="appendJt()">追加</el-button>
							<el-button size="small" type="primary" @click="saveFeeConf()">提交</el-button>
					</el-form-item>
				</el-form>
    </el-dialog>

		<el-dialog :visible.sync="productSetVistor" width="70%" >
			<el-row :gutter="20">
				<el-col :span="10">
						<el-tree
						:data="productTreeData"
						node-key="uid"
						default-expand-all
						:expand-on-click-node="false">
						<span class="custom-tree-node" slot-scope="{node,data}">
							<span>{{ node.label }}</span>
							<span>
								<el-button
									type="text"
									size="mini"
									@click="setingConf(data)"
									>
									设置
								</el-button>
							</span>
						</span>
					</el-tree>
				</el-col>
				<el-col :span="10" :visible.sync="productSetLadderVistor">
						<el-form label-width="12.5rem" :model="brandSettingForm" class="user-search">
							<el-form-item label="开通设置">
								<el-radio v-model="brandSettingForm.open" label="1">开通</el-radio>
								<el-radio v-model="brandSettingForm.open" label="2">不开通</el-radio>
							</el-form-item>
							<el-form-item label="结算折扣">
								<el-radio v-model="brandSettingForm.discountType" label="1">固定比例</el-radio>
								<el-radio v-model="brandSettingForm.discountType" label="2">按阶梯</el-radio>
							</el-form-item>
							<div v-if="brandSettingForm.discountType == '1'">
								<el-form-item label="服务比例">
									<el-input size="small" v-model="brandSettingForm.clearingRate" placeholder="请输入" style="width: 7.5rem;"></el-input>%
								</el-form-item>
							</div>
							<div v-if="brandSettingForm.discountType == '2'">
								<div v-for="(item,i ) in brandSettingForm.jtdata" v-bind="item">
									<div style="padding: top 1rem;">
										<el-input size="small" v-model="item.minAmount" placeholder="结算金额" style="width: 12.5rem;"></el-input>~<el-input size="small" v-model="item.maxAmount"  placeholder="结算金额" style="width: 12.5rem;"></el-input>
									</div>
									<div style="padding: bottom 1rem;">
										<el-input size="small" v-model="item.serviceTariffing"  placeholder="比例" style="width: 7.5rem;"></el-input>%
									</div>	
								</div>
							</div>
							<el-form-item>
									<el-button size="small" type="primary" v-if="brandSettingForm.discountType == '2'" @click="appendConfJt()">添加阶梯</el-button>
									<el-button size="small" type="primary" @click="saveConfBrand()">保存</el-button>
							</el-form-item>
						</el-form>
				</el-col>
			</el-row>
    </el-dialog>
	</div>
</template>

<script>
	import {saveBrandConfsApi,brandSettingSearchApi,searchAllApi,businessStartOrStop,advanceConfigSearchApi,settingAdvanceConfig,periodListApi,periodAddApi,serviceConfigInsertApi,serviceConfigSearchApi,cakeBrandsInfoApi} from "../../api/distributor/distributorApi.js"
	export default {
		data() {
			return {
				addPeriodVisr:false,
				settingConfVisr:false,
				productSetVistor:false,
				productSetLadderVistor:false,
				loading:false,
				activeName:'first',
				distibutorId:  this.$route.params.id,
				inputPhone: '',
				advanceAmountForm:{
					noticeAmount:'',
					phone:[],
					stopLimit:'',
					
					lastPhone:[],
					lastNoticeAmount:'',
					lastStopLimit:''
				},
				serverFeeForm:{
					serverWay: '1',
					clearingForm: '2',
					serviceTariffing: '',
					note: '',
					jtdata:[],
					periodId:''
				},
				acountDateTab:[],
				addPeriodForm:{
					dates:''
				},
				productTreeData:[],
				brandSettingForm:{
					distributorId:'',
					cityId:'',
					brandId:'',
					provinceId:'',
					level:'',
					periodId:'',
					open: 1,
					discountType: 1,
					clearingRate: '',
					jtdata:[]
				}
			}
		},
		methods: {
			appendPhone(){
				if(this.inputPhone){
					if(this.advanceAmountForm.phone.includes(this.inputPhone)){
						this.$message({
							  message:"已存在该号码",
							  type: 'warning'
						});
						this.inputPhone = ''
						return
					}
					this.advanceAmountForm.phone.push(this.inputPhone)
					this.inputPhone = ''
				}
			},
			handleClick(){
				
			},
			submitAdvanceAmount(){
				if(!this.distibutorId){
					this.$message({
						  message:"分销商信息不全",
						  type: 'warning'
					});
					return;
				}
				if(!this.advanceAmountForm.noticeAmount){
					this.$message({
						  message:"预付款余额不足提醒不可为空",
						  type: 'warning'
					});
					return;
				}
				if(!this.advanceAmountForm.stopLimit){
					this.$message({
						  message:"停止核销服务阈值",
						  type: 'warning'
					});
					return;
				}
				var saveparam = {
					distributorId: this.distibutorId,
					advanceRemind: this.advanceAmountForm.noticeAmount,
					remindPhone: this.advanceAmountForm.phone,
					stopServeValue: this.advanceAmountForm.stopLimit
				}
				settingAdvanceConfig(saveparam).then(ret=>{
					
				})
			},
			cancelAdvanceAmount(){
				this.advanceAmountForm.noticeAmount = this.advanceAmountForm.lastNoticeAmount
				this.advanceAmountForm.phone = this.advanceAmountForm.lastPhone
				this.advanceAmountForm.stopLimit = this.advanceAmountForm.lastStopLimit
			},
			getData(){
				return advanceConfigSearchApi(this.distibutorId)
			},
			appendJt(){
				this.serverFeeForm.jtdata.push({})
			},
			saveFeeConf(){
				serviceConfigInsertApi({
					distributorId: this.distibutorId,
					serverWay: this.serverFeeForm.serverWay,
					clearingForm: this.serverFeeForm.clearingForm,
					serviceTariffing: this.serverFeeForm.serviceTariffing,
					note: this.serverFeeForm.note,
					jtdata: this.serverFeeForm.jtdata,
					periodId: this.serverFeeForm.periodId
				}).then(res=>{
					console.log(res)
					this.$message({
							message:res.data.message
						});
						this.settingConfVisr = false
				})
			},
			appendPeriod(){
				this.addPeriodVisr = true
				this.addPeriodForm.dates = ''
			},
			cancelAddPeriod(){
				this.addPeriodForm.dates = ''
				this.addPeriodVisr = false
			},
			submitAddPeriod(){
				if(!this.addPeriodForm.dates){
					this.$message({
						message:'请填写账期信息'
					});
				}
				periodAddApi({
					did: this.distibutorId,
					startDate: this.addPeriodForm.dates[0],
					endDate: this.addPeriodForm.dates[1]
				}).then(res=>{
					this.addPeriodVisr = false
					periodListApi({
						did: this.distibutorId
					}).then(res=>{
						this.acountDateTab = res.data.data
						this.$message({
							message:res.data.message
						});
					})
				})
			},
			appendFeeConf(rid){
				serviceConfigSearchApi({
					did: this.distibutorId,
					period: rid
				}).then(res=>{
						if(res.data.code == '000000'){
								this.serverFeeForm = res.data.data
						}
						this.settingConfVisr = true
						this.serverFeeForm.periodId = rid
				})
				
			},
			openProductSet(rid){
				cakeBrandsInfoApi().then(res=>{
					this.productSetVistor = true
					this.productTreeData = res.data.data
					this.brandSettingForm.periodId = rid
					this.brandSettingForm.distributorId = this.distibutorId
				})
			},
			renderContent(h, { node, data, store }){
				console.log(h)
			},
			setingConf(data){
				  var param={
						did: this.brandSettingForm.distributorId,
						periodId: this.brandSettingForm.periodId,
						cityId: data['cityId'],
						brandId: data['brandId'],
						provinceId: data['provinceId'],
						level: data['level']
					}

					this.brandSettingForm.cityId = data['cityId']
					this.brandSettingForm.brandId = data['brandId']
					this.brandSettingForm.provinceId = data['provinceId']
					this.brandSettingForm.level = data['level']
					this.brandSettingForm.jtdata = []
					this.brandSettingForm.clearingRate = ''
					
					brandSettingSearchApi(param).then(res=>{
						console.log(res.data)
					})
			},
			appendConfJt(){
				this.brandSettingForm.jtdata.push({})
			},
			saveConfBrand(){
				console.log(this.distributorId)
				console.log(this.brandSettingForm.periodId)
				if(this.brandSettingForm.distributorId && this.brandSettingForm.periodId){
					saveBrandConfsApi(this.brandSettingForm).then(res=>{
						console.log(res)
					})
				}else{
					this.$message({
						message:'请选择区域'
					});
				}
			}
		},
		created() {
		  this.getData().then(ret=>{
				console.log(ret.data)
				if(ret.data.code == '000000'){
					this.advanceAmountForm.noticeAmount = ret.data.data.advanceRemind
					this.advanceAmountForm.lastNoticeAmount = ret.data.data.advanceRemind
					this.advanceAmountForm.phone = ret.data.data.remindPhone
					this.advanceAmountForm.stopLimit = ret.data.data.stopServeValue
					this.advanceAmountForm.lastStopLimit = ret.data.data.stopServeValue
					this.advanceAmountForm.lastPhone = ret.data.data.remindPhone
				}
			})
			periodListApi({
				did: this.distibutorId
			}).then(res=>{
				this.acountDateTab = res.data.data
			})
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/distributor/distributorSetting.vue